import { useQuery } from '@tanstack/react-query';
import { apiFetch } from 'utils/apiUtils.ts';
import { CampaignDetails } from 'schemas/CampaignsList.schema.ts';
import useAuth from 'hooks/useAuth.ts';

export default function useFetchCampaigns({ teamIds }: { teamIds: string[] }) {
  const { tokens } = useAuth();

  return useQuery({
    queryKey: ['campaigns'],
    queryFn: async (): Promise<{[key: string]: CampaignDetails[]}> => {
      const campaignsByTeam: {[key: string]: CampaignDetails[]} = {};

      // eslint-disable-next-line no-restricted-syntax
      for (const teamId of teamIds) {
        // eslint-disable-next-line no-await-in-loop
        campaignsByTeam[teamId] = await apiFetch<CampaignDetails[]>({
          path: `team/${teamId}/campaign`,
          method: 'GET',
          accessToken: String(tokens.accessToken),
        });
      }

      return campaignsByTeam;
    },
    enabled: !!teamIds.length,
  });
}
